import { render, staticRenderFns } from "./TaskBook.vue?vue&type=template&id=133e1c02&scoped=true"
import script from "./TaskBook.vue?vue&type=script&lang=js"
export * from "./TaskBook.vue?vue&type=script&lang=js"
import style0 from "./TaskBook.vue?vue&type=style&index=0&id=133e1c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e1c02",
  null
  
)

export default component.exports